<template>
  <div>
    <b-card>
      <ValidationObserver ref="observer">
        <b-form @submit.prevent="handleSubmit">
          <b-card-header>
            <span class="d-flex align-items-center">
              <feather-icon icon="FileTextIcon" size="20" />
              <h2 class="mb-0 ml-50">Informações básicas</h2>
            </span>
          </b-card-header>

          <b-row
            class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
          >
            <b-col cols="12" md="4">
              <b-form-group>
                <label
                  for="client_name"
                  class="text-center font-weight-bold text-primary"
                >
                  Nome do cliente :
                </label>
                <validation-provider
                  #default="{ errors }"
                  :custom-messages="{ required: 'Este campo é obrigatório' }"
                  rules="required"
                >
                  <BFormInput
                    id="client_name"
                    type="text"
                    v-model="item.name"
                  ></BFormInput>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="3">
              <b-form-group>
                <label class="text-center font-weight-bold text-primary"
                  >Tipo de Pessoa:</label
                >
                <b-form-radio-group v-model="item.project_type">
                  <b-form-radio value="pessoa_fisica"
                    >Pessoa Física</b-form-radio
                  >
                  <b-form-radio value="pessoa_juridica"
                    >Pessoa Jurídica</b-form-radio
                  >
                </b-form-radio-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="3">
              <b-form-group>
                <label
                  for="document"
                  class="text-center font-weight-bold text-primary"
                >
                  {{ item.project_type === 'pessoa_fisica' ? 'CPF' : 'CNPJ' }}:
                </label>
                <validation-provider
                  #default="{ errors }"
                  :custom-messages="{ required: 'Este campo é obrigatório' }"
                  rules="required"
                >
                  <b-form-input
                    v-if="item.project_type === 'pessoa_fisica'"
                    id="document"
                    v-model="item.num_doc"
                    placeholder="Digite o CPF"
                    v-mask="'###.###.###-##'"
                    :disabled="item.project_type === ''"
                  ></b-form-input>
                  <b-form-input
                    v-else
                    id="document"
                    v-model="item.num_doc"
                    placeholder="Digite o CNPJ"
                    v-mask="'##.###.###/####-##'"
                    :disabled="item.project_type === ''"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <label
                for="document"
                class="text-center font-weight-bold text-primary"
                >Cod Projeto:
              </label>
              <BFormInput type="text" v-model="item.acronym"></BFormInput>
            </b-col>
          </b-row>

          <!-- Nome do contato -->
          <b-row
            class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
          >
            <b-col cols="12" md="4">
              <b-form-group>
                <label
                  for="contact_name"
                  class="text-center font-weight-bold text-primary"
                >
                  Nome do contato :
                </label>
                <BFormInput type="text" v-model="item.responsible"></BFormInput>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="3">
              <b-form-group>
                <label
                  for="contact_document"
                  class="text-center font-weight-bold text-primary"
                >
                  CPF do contato :
                </label>
                <BFormInput
                  id="contact_document"
                  type="text"
                  v-mask="'###.###.###-##'"
                  v-model="item.contact_document"
                ></BFormInput>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="2">
              <b-form-group>
                <label
                  for="contact_phone"
                  class="text-center font-weight-bold text-primary"
                >
                  Telefone :
                </label>
                <BFormInput
                  id="contact_phone"
                  type="tel"
                  v-mask="'(##)#####-####'"
                  v-model="item.phone"
                ></BFormInput>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group>
                <label class="text-center font-weight-bold text-primary">
                  E-mail:
                </label>
                <ValidationProvider
                  name="E-mail"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <b-form-input
                    v-model="item.email"
                    type="email"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="my-1 pl-2 pr-2 text-left d-flex">
            <b-card-header>
              <span class="d-flex align-items-center">
                <feather-icon icon="FileTextIcon" size="20" />
                <h2 class="mb-0 ml-50">Endereço</h2>
              </span>
            </b-card-header>
          </b-row>
          <b-row
            class="my-1 mx-2 pl-2 pr-2 text-left d-flex justify-content-center"
          >
            <b-col cols="12" md="6">
              <b-form-group>
                <label for="description" class="font-weight-bold text-primary"
                  >CEP :</label
                >
                <BFormInput
                  id="description"
                  type="text"
                  v-model="item.zip_code"
                  @keyup="getInfoCep()"
                  v-mask="'#####-###'"
                ></BFormInput>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group>
                <label for="description" class="font-weight-bold text-primary"
                  >Bairro :</label
                >
                <BFormInput
                  id="description"
                  type="text"
                  v-model="item.neighborhood"
                ></BFormInput>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="8">
              <b-form-group>
                <label for="description" class="font-weight-bold text-primary"
                  >Logradouro :</label
                >
                <BFormInput
                  id="description"
                  type="text"
                  v-model="item.street"
                ></BFormInput>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group>
                <label for="description" class="font-weight-bold text-primary"
                  >Número :</label
                >
                <BFormInput
                  id="description"
                  type="text"
                  v-model="item.number"
                ></BFormInput>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group>
                <label for="description" class="font-weight-bold text-primary"
                  >País :</label
                >
                <BFormInput
                  id="description"
                  type="text"
                  v-model="item.country"
                ></BFormInput>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mx-2 pl-2 pr-2 text-left d-flex justify-content-center">
            <b-col cols="12" md="6">
              <b-form-group>
                <label for="description" class="font-weight-bold text-primary"
                  >Cidade :</label
                >
                <BFormInput
                  id="description"
                  type="text"
                  v-model="item.city"
                ></BFormInput>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group>
                <label for="description" class="font-weight-bold text-primary"
                  >Estado :</label
                >
                <v-select
                  id="custon-select-local"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Selecione"
                  v-model="item.state"
                  :options="listState"
                  :reduce="(option) => option.value"
                  :getOptionLabel="(item) => item.label"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="my-1 pl-2 pr-2 text-left d-flex">
            <b-card-header>
              <span class="d-flex align-items-center">
                <feather-icon icon="FileTextIcon" size="20" />
                <h2 class="mb-0 ml-50">Detalhes</h2>
              </span>
            </b-card-header>
          </b-row>
          <b-row
            class="my-1 mx-2 pl-2 pr-2 text-left d-flex justify-content-center"
          >
            <b-col cols="12" md="8">
              <b-form-group>
                <label for="description" class="font-weight-bold text-primary"
                  >Responsável Legal :</label
                >
                <BFormInput
                  id="description"
                  type="text"
                  v-model="item.legal_responsible"
                ></BFormInput>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group>
                <label for="description" class="font-weight-bold text-primary"
                  >Reg. Responsável Legal :</label
                >
                <BFormInput
                  id="description"
                  type="text"
                  v-model="item.register_legal_responsible"
                ></BFormInput>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            class="my-1 mx-2 pl-2 pr-2 text-left d-flex justify-content-center"
          >
            <b-col cols="12" md="8">
              <b-form-group>
                <label for="description" class="font-weight-bold text-primary"
                  >Setor de atuação :</label
                >
                <BFormInput
                  id="description"
                  type="text"
                  v-model="item.sector"
                ></BFormInput>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group>
                <label for="description" class="font-weight-bold text-primary"
                  >Tamanho da empresa :</label
                >
                <BFormInput
                  id="description"
                  type="text"
                  v-model="item.company_size"
                ></BFormInput>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />

          <b-row class="justify-content-between p-3">
            <b-col cols="auto" class="text-left">
              <b-button variant="warning" @click="$router.go(-1)"
                >Voltar
              </b-button>
            </b-col>
            <b-col cols="auto" class="text-right">
              <b-button variant="primary" type="submit" :disabled="!isFormValid"
                >{{ !editable ? 'Salvar' : 'Atualizar' }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>
    </b-card>
  </div>
</template>
<script>
import {
  BButton,
  BCard,
  BCardHeader,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BRow,
} from 'bootstrap-vue';

import { cepDao } from '@/service';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

extend('required', {
  ...required,
  message: 'Este campo é obrigatório',
});

extend('email', {
  ...email,
  message: 'Digite um e-mail válido',
});

export default {
  name: '',
  components: {
    BCard,
    BForm,
    BCardHeader,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormRadio,
    BFormRadioGroup,
    ValidationProvider,
    ValidationObserver,
    BButton,
  },

  data() {
    return {
      editable: false,
      listState: [
        { label: 'Acre', value: 'AC' },
        { label: 'Alagoas', value: 'AL' },
        { label: 'Amapá', value: 'AP' },
        { label: 'Amazonas', value: 'AM' },
        { label: 'Bahia', value: 'BA' },
        { label: 'Ceará', value: 'CE' },
        { label: 'Distrito Federal', value: 'DF' },
        { label: 'Espírito Santo', value: 'ES' },
        { label: 'Goiás', value: 'GO' },
        { label: 'Maranhão', value: 'MA' },
        { label: 'Mato Grosso', value: 'MT' },
        { label: 'Mato Grosso do Sul', value: 'MS' },
        { label: 'Minas Gerais', value: 'MG' },
        { label: 'Pará', value: 'PA' },
        { label: 'Paraíba', value: 'PB' },
        { label: 'Paraná', value: 'PR' },
        { label: 'Pernambuco', value: 'PE' },
        { label: 'Piauí', value: 'PI' },
        { label: 'Rio de Janeiro', value: 'RJ' },
        { label: 'Rio Grande do Norte', value: 'RN' },
        { label: 'Rio Grande do Sul', value: 'RS' },
        { label: 'Rondônia', value: 'RO' },
        { label: 'Roraima', value: 'RR' },
        { label: 'Santa Catarina', value: 'SC' },
        { label: 'São Paulo', value: 'SP' },
        { label: 'Sergipe', value: 'SE' },
        { label: 'Tocantins', value: 'TO' },
      ],
      item: {
        name: '',
        fantasy_name: '',
        num_doc: '',
        email: '',
        phone: '',
        cellphone: '',
        acronym: '',
        zip_code: '',
        street: '',
        neighborhood: '',
        number: '',
        city: '',
        state: '',
        responsible: '',
        project_type: '',
        legal_responsible: '',
        register_legal_responsible: '',
        sector: '',
        company_size: '',
      },
      required,
      isFormValid: false,
    };
  },
  watch: {
    item: {
      handler() {
        this.validateForm();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    currentWorkspace() {
      return this.$store.getters.currentWorkspace;
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.editable = true;
      this.getClient();
    }
  },
  methods: {
    getClient() {
      let id = this.$route.params.id;
      this.$store
        .dispatch('getClient', id)
        .then((resp) => {
          this.item = resp;
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao resgatar cliente.',
              icon: 'XIcon',
              variant: 'danger',
            },
          });
        });
    },
    async validateForm() {
      if (this.$refs.observer) {
        const valid = await this.$refs.observer.validate();
        this.isFormValid = valid;
      } else {
        console.warn('Observer não está disponível');
      }
    },
    async handleSubmit() {
      const valid = await this.$refs.observer.validate();
      if (valid) {
        console.log('Formulário válido:', this.item);
        let dispatcher = '';

        if (this.editable) {
          dispatcher = 'updateClient';
        } else {
          dispatcher = 'createClient';
        }

        this.$store
          .dispatch(dispatcher, {
            ...this.item,
            fantasy_name: this.item.name,
            phone: this.onlyNumbers(this.item.phone),
            cellphone: this.onlyNumbers(this.item.phone),
            num_doc: this.onlyNumbers(this.item.num_doc),
            zip_code: this.onlyNumbers(this.item.zip_code),
            workspace_id: this.currentWorkspace.id,
            integration: this.currentWorkspace.quality_id ? true : false,
            company_id: this.currentWorkspace.quality_id
              ? this.currentWorkspace.quality_id
              : false,
          })
          .then((resp) => {
            console.log(resp);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.editable
                  ? 'Cliente atualizado com sucesso.'
                  : 'Cliente adicionado com sucesso.',
                icon: 'CheckIcon',
                text: 'Officearch / V-Quality',
                variant: 'success',
              },
            });
            this.$router.go(-1);
          })
          .catch((err) => {
            let errorMsg = 'Erro desconhecido';

            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                errorMsg = err.response.data;
              } else if (err.response.data.message) {
                errorMsg =
                  err &&
                  err.response &&
                  err.response.data &&
                  err.response.data.error &&
                  err.response.data.error.error &&
                  err.response.data.error.error.detail
                    ? err.response.data.error.error.detail
                    : err.response.data.error.message;
              } else {
                errorMsg = JSON.stringify(err.response.data);
              }
            } else if (err.message) {
              errorMsg = err.message;
            }

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Erro ao adicionar cliente.',
                icon: 'XIcon',
                text: errorMsg,
                variant: 'danger',
              },
            });
          });
      }
    },
    getInfoCep() {
      if (this.item.zip_code != null && this.item.zip_code.length === 9)
        cepDao
          .get(this.item.zip_code)
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            console.log(json);
            if (json.logradouro) this.item.street = json.logradouro;
            if (json.bairro) this.item.neighborhood = json.bairro;
            if (json.localidade) this.item.city = json.localidade;
            if (json.uf) this.item.state = json.uf;
            this.item.country = 'Brasil';
          });
    },
  },
};
</script>
<style lang="" scoped></style>
